import { ParseAdapter } from '../abstract/ParseAdapter';

export class DefinitionChecklist extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get key(): string { return this.parseObject.get('key'); }
    set key(value: string) { this.parseObject.set('key', value); }

    get labelFr(): string { return this.parseObject.get('labelFr'); }
    set labelFr(value: string) { this.parseObject.set('labelFr', value); }

    get isVisible(): boolean { return this.parseObject.get('isVisible'); }
    set isVisible(value: boolean) { this.parseObject.set('isVisible', value); }
}



// WEBPACK FOOTER //
// ./src/app/model/definition-checklist.model.ts